var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryService(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15587 2.58691L0.705957 4.41793C0.646869 4.44889 0.591068 4.48415 0.53833 4.52273L9.36008 9.12288L13.0542 7.29571L4.15587 2.58691Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1214 5.5459L14.708 7.72879V10.188C14.708 10.4973 14.4572 10.7481 14.1479 10.7481C13.8386 10.7481 13.5878 10.4973 13.5878 10.188V8.28284L9.91309 10.1004V19.0007C9.92459 18.9954 9.93624 18.9905 9.94763 18.9848L18.3956 14.7043C18.8444 14.4799 19.1231 14.029 19.1231 13.5271V5.59539C19.1231 5.57877 19.122 5.56237 19.1214 5.5459Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3957 4.41796L9.95128 0.139243L9.94777 0.137488C9.57177 -0.0497108 9.12498 -0.0455276 8.75249 0.148693L5.35132 1.95379L14.2918 6.68488L18.6072 4.55044C18.5417 4.50054 18.4714 4.45576 18.3957 4.41796Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00265186 5.50879C0.00115785 5.53445 0 5.56015 0 5.58607V13.5372C0 14.0288 0.270415 14.4753 0.705767 14.7033L8.74892 18.9721L8.75254 18.974C8.76591 18.981 8.77958 18.9872 8.79314 18.9936V10.0926L0.00265186 5.50879Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryService);
export default __webpack_public_path__ + "static/media/delivery-service.1274d55e4b1bbff70bcf0c70f92bdba1.svg";
export { ForwardRef as ReactComponent };